import { type NumericalDataType } from '../../../../shared/models/numerical-data-type'

export enum DiffType {
  Regular,
  Inverse,
  Neutral
}

export enum KPIType {
  TimesPlayed = 'times_played',
  UniqueListeners = 'unique_listeners',
  BuyNowClicks = 'buy_now_clicks',
  PresaleCodes = 'presale_codes',
  MeetAndGreet = 'meet_and_greet',
  Vip = 'vip',
  Rsvp = 'rsvp',
  Messages = 'messages',
  UniqueChatters = 'unique_chatters',
  SongsPlayed = 'songs_played',
  VideosViewed = 'videos_viewed',
  LivestreamParticipation = 'livestream_participation',
  ForumViews = 'views',
  ForumPosts = 'posts',
  ForumComments = 'comments',
  ForumUpvotes = 'upvotes'
}

export const KPIDiffType: Record<KPIType, DiffType> = {
  [KPIType.TimesPlayed]: DiffType.Regular,
  [KPIType.UniqueListeners]: DiffType.Regular,
  [KPIType.BuyNowClicks]: DiffType.Regular,
  [KPIType.PresaleCodes]: DiffType.Regular,
  [KPIType.MeetAndGreet]: DiffType.Regular,
  [KPIType.Vip]: DiffType.Regular,
  [KPIType.Rsvp]: DiffType.Regular,
  [KPIType.Messages]: DiffType.Regular,
  [KPIType.UniqueChatters]: DiffType.Regular,
  [KPIType.SongsPlayed]: DiffType.Regular,
  [KPIType.VideosViewed]: DiffType.Regular,
  [KPIType.LivestreamParticipation]: DiffType.Regular,
  [KPIType.ForumViews]: DiffType.Regular,
  [KPIType.ForumPosts]: DiffType.Regular,
  [KPIType.ForumComments]: DiffType.Regular,
  [KPIType.ForumUpvotes]: DiffType.Regular
}

export const KPISign: Record<KPIType, 'positive' | 'negative'> = {
  [KPIType.TimesPlayed]: 'positive',
  [KPIType.UniqueListeners]: 'positive',
  [KPIType.BuyNowClicks]: 'positive',
  [KPIType.PresaleCodes]: 'positive',
  [KPIType.MeetAndGreet]: 'positive',
  [KPIType.Vip]: 'positive',
  [KPIType.Rsvp]: 'positive',
  [KPIType.Messages]: 'positive',
  [KPIType.UniqueChatters]: 'positive',
  [KPIType.SongsPlayed]: 'positive',
  [KPIType.VideosViewed]: 'positive',
  [KPIType.LivestreamParticipation]: 'positive',
  [KPIType.ForumViews]: 'positive',
  [KPIType.ForumPosts]: 'positive',
  [KPIType.ForumComments]: 'positive',
  [KPIType.ForumUpvotes]: 'positive'
}

export class KPI {
  constructor(
    public readonly id: KPIType,
    public readonly value: number | undefined,
    public readonly type: NumericalDataType,
    public readonly progressRatio: number,
    public readonly prevValue?: number
  ) {}
}

export interface KPIVM {
  readonly id: KPIType
  readonly value?: number
  readonly type?: NumericalDataType
  readonly progressRatio?: number
  readonly prevValue?: number
}
